import React from "react";
import type { PreviewProps } from "../types";

export function EventPreview({ postable, displayType }: PreviewProps) {
  // Since this is a placeholder, we'll keep it simple
  const imageUrl =
    postable.postable.imageUrl || "https://placehold.co/600x400/png";
  const title = postable.postable.title || "Event";

  if (displayType === "horizontal") {
    return (
      <div className="relative rounded-lg overflow-hidden w-full h-[160px] shadow-sm">
        <div
          className="w-full h-full bg-cover bg-center"
          style={{ backgroundImage: `url(${imageUrl})` }}
        />
        <div className="absolute bottom-0 left-0 right-0 bg-black/50 p-2">
          <div className="text-white font-semibold text-center">{title}</div>
        </div>
      </div>
    );
  }

  // Default placeholder for other display types
  return (
    <div className="flex flex-col items-center justify-center h-full p-6 text-center text-muted-foreground">
      <p>Event preview for {displayType} display type</p>
      <p className="text-xs mt-1">{title}</p>
    </div>
  );
}
